import type {
  SurveyAnswerRecord,
  SurveyAnswerValue,
  SurveyElementJson,
} from '@coorum-research/shared-common/types'
import type { SurveyModel } from 'survey-core'
import type { SurveyElementFormHandler } from './survey-element-form'

export class SurveyElementFormHandlerSurveyModel implements SurveyElementFormHandler {
  readonly #elementJson: SurveyElementJson
  readonly #surveyModel: SurveyModel | null

  constructor(
    elementJson: SurveyElementJson,
    surveyModel: SurveyModel | null,
  ) {
    this.#elementJson = elementJson
    this.#surveyModel = surveyModel
  }

  get elementJson(): SurveyElementJson {
    return this.#elementJson
  }

  get surveyModel(): SurveyModel | null {
    return this.#surveyModel
  }

  get data(): SurveyAnswerRecord {
    return this.#surveyModel?.data || {}
  }

  getValue(): SurveyAnswerValue {
    return this.#surveyModel?.getValue(this.#elementJson.name)
  }

  getComment(): string {
    return this.#surveyModel?.getComment(this.#elementJson.name) || ''
  }

  setElementResultRecordValue(_value: SurveyAnswerValue) {
    // nothing to do
  }

  setElementResultRecordComment(_comment: string) {
    // nothing to do
  }

  /**
   * formSchemaがある場合は、zodでvalidateする (@see createSurveyElementSchema)
   * formSchemaがない場合は、surveyModelでvalidateする
   */
  validate(): {
    isValid: boolean
    errorMessage?: string
  } {
    return {
      isValid: this.#surveyModel?.validate() ?? true,
    }
  }
}
